<!-- tablesearchmiscellaneousreimbursement.vue -->
<template>
    <div>
      <HeadDetailsGama :titleHead="'Retornar Listagem'"  :buttontemplate="true" :buttonbackCustom="true" style="font-family: 'Segoe UI';" >
          <template #button-edit>
              <div class="d-flex" v-if="propQma.statusApr == 0">
                  <div class="cancelar">
                      <button class="button-cancel" >CANCELAR</button>
                  </div>
                  <div class="criar ml-3">
                      <button class="button-save">SALVAR</button>
                  </div>
              </div>
        </template>
      </HeadDetailsGama>
      <mediaslistQma ref="mediaApr" :listWithImg="listWithImg" :isPdf=false></mediasListQma>
    </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import mediaslistQma from '@/views/private/qma/inqueryQma/components/details/mediasQma/components/mediasListQma'
import inqueryQmaRepository from '@/shared/http/repositories/business/qmaInquery'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'midiasQma',
  mixins: [ActionsForm],
  components: {HeadDetailsGama, mediaslistQma, inqueryQmaRepository},
  data () {
    return {
      listMidia: null,
      listImg: [],
      listWithImg: []
    }
  },
  props: ['propQma', 'qma', 'idQma'],
  watch: {
    // Se o usuário trocar de QMA selecionado sem desmontar a aba,
    // recarrega as mídias do novo QMA.
    idQma (newId, oldId) {
      if (newId && newId !== oldId) {
        this.onLoad()
      }
    }
  },
  // O parent monta esse componente apenas quando o usuário clica na aba Mídias
  // (via v-if="tabIndex === 2"). Disparar onLoad aqui garante que a busca acontece
  // sempre que a aba for aberta — sem isso, o componente sobe vazio e fica em
  // "Nenhum registro encontrado".
  mounted () {
    this.onLoad()
  },
  methods: {
    async onLoad () {
      if (!this.idQma) return
      loading.push()
      inqueryQmaRepository.GetQmaMedias({qmaId: this.idQma, fluxo: this.qma})
        .then((Response) => {
          this.listImg = Response.data || []
          this.listWithImg = this.listImg.filter(x => x.urlImagem !== null && x.urlImagem !== '')
          loading.pop()
        })
        .catch((err) => {
          loading.pop()
          console.log(err)
        })
    }
  }
}

</script>

<style scoped>
.buttons-table-action{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: right;
    align-items: center;
}

.btn-generate-lote {
    height: 2rem;
    padding: 0 1rem;
    background: #008144;
    color: white;
    border-radius: 8px;
    border: none;
    font-weight: bold;
}
.btn-generate-lote:hover{
    background: #024d2a;
}

.form-inputs{
    width: 100%;
    padding: 0.5rem 0;
}
.labelsearch{
    font-weight: 700;
    color: #666;
    font-size: 14px;
    margin-bottom: 5px;
    padding-bottom: 0;
    font-family: 'Segoe UI';
}
.input-paddi{
  padding-left: 28px;
}

.button-cancel,
.button-save{
margin-top: 10;
outline: transparent;
border: transparent;
border-radius: 4px;
text-transform: uppercase;
width: 190px;
height: 40px;
}

.container_cancel_save{
justify-content: center;
width: 100%;
margin-top: 1.5rem;
column-gap: 10px;
}

.button-cancel{
background-color: #D8D8D8;
color: #636363;
}
.button-save{
background-color: #008148;
color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/components/details/mediasQma/mediasQma.vue